import { Factory } from '@infodata-group/inf-commons';
import { Product } from '../model/product';
import { DtoProductInterface } from '../interface/dto-product.interface';

export class ProductFactory implements Factory<Product> {
  build(o: DtoProductInterface): Product {
    const product: Product = new Product(o.id, o.label);
    product.children = o.children;

    return product;
  }

  getApi(): string {
    return 'products';
  }
}
